import styled from 'styled-components'
import {
	media,
	Breakpoints,
	container,
	themeObject,
	textModels,
} from 'Pages/landings/newLandings/common/style'

export const Block = styled.div`
	${container} {
		background: ${themeObject.colors.grey[900]};
	}
`
export const Wrapper = styled.div`
	padding: 24px 24px 32px;
	${media('padding: 24px 32px 32px', Breakpoints.ms)}
	${media('padding: 32px 72px 40px', Breakpoints.lx)} 
	${media('padding: 32px 75px 40px; width: 1216px', Breakpoints.xl)}
`

export const BottomWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	${media('flex-direction: row; gap: 32px; justify-content: space-between;', Breakpoints.lx)}
`

export const Text = styled.p`
	display: block;
	width: 100%;
	word-wrap: break-word;
	${textModels('notAdaptive', 'xs', '400')};
	color: ${themeObject.colors.grey[500]};
	> a,
	p > a {
		color: ${themeObject.colors.grey[500]};
		text-decoration: underline;
	}
`

export const Divider = styled.hr`
	margin-top: 15px;
	margin-bottom: 16px;
	border: none;
	border-top: 1px solid ${themeObject.colors.primary.highlight[20]};
`
